import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { copyToClipboard } from '../../../../../../utils/helper';

const FileUrl = ({ url }) => {
  const [copyUrl, setCopyUrl] = useState('');

  const onCopyUrl = (url) => {
    setCopyUrl(url)
  }

  useEffect(() => {
    if (copyUrl) {
      copyToClipboard(copyUrl)
      setTimeout(() => {
        setCopyUrl('')
      }, 1300)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyUrl])

  if (!url) {
    return null;
  }

  return (
    <>
      {url}
      {copyUrl === url
        ? (
          <OverlayTrigger
            overlay={<Tooltip id={url}>Copied</Tooltip>}
            placement="top"
            delayHide={1000}
          >
            <span className="files-table__url-copy fal fa-copy" />
          </OverlayTrigger>
        ) : <span className="files-table__url-copy fal fa-copy" onClick={() => onCopyUrl(url)} />}
    </>
  )
};

FileUrl.propTypes = {
  url: PropTypes.string,
};

export default FileUrl;
